@if (appReady()) {
  <ng-container>
    <app-navigation-menu class="nav-menu">
      @if (platformReady()) {
        <main class="main-content" [ngClass]="{ isFullView: isFullView() }">
          <router-outlet></router-outlet>
        </main>
      }
    </app-navigation-menu>
    @if (isNotAgreedTerms) {
      <app-license-agreement class="license-overlay"></app-license-agreement>
    }
  </ng-container>
}
@if (!isDirectAccess) {
  <app-splash-screen />
}

<app-spinner />

<app-toast />
